import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ReportRecipient } from '@app/interfaces/lm/report-schedules';
import { ProjectStatistics } from '@app/interfaces/lm/task';
import { ViewTestCaseProgressComponent } from '@app/shared/components/view-test-case-progress/view-test-case-progress.component';
import { SettingsService } from '@services/sys/settings.service';
import { EChartsOption } from 'echarts';
import { ECharts } from 'echarts/core';

@Component({
    selector: 'app-progress-circle',
    templateUrl: './progress-circle.component.html',
    styleUrls: ['./progress-circle.component.less'],
})
export class ProgressCircleComponent implements OnInit {
    @ViewChild('viewProgress') viewProgress!: ViewTestCaseProgressComponent;
    @Input() progressTitle!: string;
    @Input('value') set set_value(value: number) {
        this.value = value;
        this.updateCharts();
    }
    value = 0;
    @Input() totalCount!: number | string;
    @Input() count!: number;
    @Input() isTestCase = false;
    @Input() projectId!: string;
    @Input() projectGroupId!: string;
    @Input() currentUser!: ReportRecipient;
    charts?: ECharts;
    options: EChartsOption = {};

    constructor(private settingsService: SettingsService) {
    }

    ngOnInit(): void {
    }

    async onChartInit(charts: ECharts): Promise<void> {
        this.charts = charts;
        this.charts.showLoading();
        this.updateCharts();
    }

    updateCharts(): void {
        const update = () => {
            if (this.charts) {
                this.charts.hideLoading();
                this.charts.setOption(this.getChartOptions(), true);
            }
        };
        const ensureUpdate = () => {
            if (!this.charts) {
                setTimeout(ensureUpdate, 500);
                return;
            }
            update();
        };
        ensureUpdate();
    }

    getChartOptions(): EChartsOption {
        this.options = {
            series: [
                {
                    type: 'gauge',
                    startAngle: 90,
                    endAngle: -270,
                    center: ['50%', '50%'], // 中心点
                    radius: '100%', // 圆大小
                    pointer: {
                        show: false,
                    },
                    progress: {
                        show: true,
                        overlap: false, // 多组数据时进度条是否重叠
                        roundCap: true, // 是否在两端显示成圆形
                        clip: false, // 是否裁掉超出部分
                        itemStyle: {
                            borderWidth: 0,
                            shadowColor: '',
                            color: this.settingsService.getGaugeColor(this.value)
                        },
                    },
                    axisLine: {
                        lineStyle: {
                            width: 12, // 圆环宽度
                            color: [[1, '#ccc']], // 圆环背景色
                        },
                    },
                    splitLine: {
                        // 仪表盘分割线
                        show: false,
                    },
                    axisTick: {
                        // 刻度样式
                        show: false,
                    },
                    axisLabel: {
                        // 刻度标签
                        show: false,
                    },
                    data: [
                        {
                            value: this.value,
                            title: {},
                            detail: {
                                // 中心title设置
                                offsetCenter: ['0%', '0%'],
                                color: '#000',
                                formatter: (value: number) => {
                                    return (!value ? 0 : value) + '%';
                                },
                            },
                        },
                    ],
                    title: {
                        fontSize: 14,
                    },
                    detail: {
                        fontSize: 14,
                        color: 'auto',
                    },
                },
            ],
        };
        return this.options;
    }

    view(): void {
        const isProject = !!this.projectId;
        this.viewProgress?.open(this.projectId || this.projectGroupId, isProject);
    }
}
